import { useCallback, useState } from 'react';
import { type ToastMessageType } from '../../../common/enums/ToastMessageType';
import { getErrorToastMessage } from '../../../helpers';

interface VoteSuccessResult {
  voteCount: number;
  score?: number;
  hasReachedFinalMilestone?: boolean;
}

export const useIdeaVoteState = (initialVoteCount: number | null, initialScore: number | null) => {
  const [voteCount, setVoteCount] = useState(initialVoteCount);
  const [score, setScore] = useState(initialScore);
  const [toastMessages, setToastMessages] = useState<ToastMessageType[]>();
  const [portalTarget, setPortalTarget] = useState<HTMLDivElement | null>(null);

  const portalTargetRef = useCallback((node: HTMLDivElement | null) => {
    setPortalTarget(node);
  }, []);

  const handleVoteSuccess = useCallback(({ voteCount: vc, score: sc }: VoteSuccessResult) => {
    setVoteCount(vc);
    if (sc !== undefined) setScore(sc);
  }, []);

  const handleVoteError = useCallback((message: string) => {
    setToastMessages(getErrorToastMessage(message));
  }, []);

  return {
    voteCount,
    score,
    toastMessages,
    portalTarget,
    portalTargetRef,
    handleVoteSuccess,
    handleVoteError
  };
};
